import { defineMessages } from 'react-intl'

const scope = `procurify.components.CopyToClipboardButton`

export default defineMessages({
  tooltipTextInitial: {
    id: `${scope}.tooltipTextInitial`,
    defaultMessage: 'Copy to clipboard',
  },
  tooltipTextCopied: {
    id: `${scope}.tooltipTextCopied`,
    defaultMessage: 'Copied!',
  },
})
